import { createRouter, createWebHistory } from 'vue-router';
import { internalLoginRedirect } from '../utils/login-redirect';
import { useAuthStore } from '@/stores/auth';
import { i18n } from '@/i18n';
import { routes } from './routes';
import { PLANNER_WORKSPACE_ENABLED } from '@dsv/shared';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: (_to, _from, savedPosition) => savedPosition ?? { top: 0 },
});

router.beforeEach(async (to) => {
  if(to.meta.factoryPortal)return true;
  const auth = useAuthStore();

  // 首次进入或刷新页面时，先用本地令牌恢复会话，再决定放不放行
  await auth.restore();

  const requiresAuth = to.meta.requiresAuth !== false;

  if (requiresAuth && !auth.isLoggedIn) {
    // 记下原目标，登录后跳回去
    return { name: 'login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } };
  }

  // 已登录还去登录页，直接送回工作台
  if (to.name === 'login' && auth.isLoggedIn) {
    const redirect = internalLoginRedirect(to.query.redirect);
    if (redirect && router.resolve(redirect).name !== 'login') return redirect;
    return { name: 'dashboard' };
  }

  const required = to.meta.permissions;
  if (to.meta.plannerWorkspace && !PLANNER_WORKSPACE_ENABLED) return { name: 'dashboard' };
  if (required?.length && !auth.can(...required)) {
    return { name: 'forbidden' };
  }
  if (to.meta.anyPermissions?.length && !auth.canAny(...to.meta.anyPermissions)) return { name: 'forbidden' };

  // 开发阶段的辅助页只给管理员（普通用户直敲 URL 也拦下）
  if (to.meta.adminOnly && !auth.isAdministrator) {
    return { name: 'forbidden' };
  }
  // 2026-10-23：管理员可查看全部页面（原来这里把管理员挡回工作台）。
  // businessOnly 仅用于「不给非业务角色」的场景，管理员需要能进去排查与核对。

  return true;
});

router.afterEach((to) => {
  const appName = to.meta.factoryPortal ? 'E·LAND GROUP' : i18n.global.t('app.name');
  const pageTitle = to.meta.titleKey ? i18n.global.t(to.meta.titleKey) : '';
  document.title = pageTitle ? `${pageTitle} · ${appName}` : appName;
  const icon=document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if(icon)icon.href=`${import.meta.env.BASE_URL}${to.meta.factoryPortal?'supplier-portal.svg':'favicon.svg'}`;
});
